const snakecase = string =>
  string
    .split(/(?=[A-Z])/)
    .map(subString => subString.toLowerCase())
    .join('_');

const snakecaseKeys = obj => {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }
  let result = {};
  Object.keys(obj).forEach(key => {
    result[snakecase(key)] = snakecaseKeys(obj[key]);
  });
  return result;
};

export default snakecaseKeys;
